import session from '../auth_api/session'

const URL = process.env.VUE_APP_API_URL

export default {
  namespaced: true,
  state: {
    data: { 'results': [] },
    statuses: [],
    currentRegistry: {
      'list_num_class': [],
      'list_letter_class': [],
      'list_npd': []
    }
  },
  mutations: {
    setData (state, payload) {
      state.data = payload
    },
    setItem (state, payload) {
      let data = state.data.results
      for (let i in data) {
        if (data[i]['id'] === payload.id) {
          Object.assign(data[i], payload)
          break
        }
      }
    },
    pushItem (state, payload) {
      state.data.results.push(payload)
    },
    setStatuses (state, payload) {
      state.statuses = payload
    },
    setCurrentRegistry (state, payload) {
      state.currentRegistry = payload
    }
    // deleteItem (state, payload) {
    //   let data = state.data.results
    //   for (let i in data) {
    //     if (data[i]['id'] === payload.id) {
    //       data.splice(i, 1)
    //       break
    //     }
    //   }
    // }
  },
  actions: {
    fetchData ({ commit }, payload) {
      let _url = URL + 'school/api/' + payload.table + '/'
      let params = {}
      if ((0 + payload.pageId) > 1) {
        params['page'] = payload.pageId
      }
      return session.get(_url, { params: params })
    },
    updateData ({ commit }, payload) {
      return session.put(URL + 'school/api/list-food/' + payload.item.id + '/', payload.item)
    },
    fetchStatuses ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', 'fetchStatuses', { root: true })
        let _url = URL + 'school/api/list-registry-status/'
        session.get(_url)
          .then(response => {
            commit('setStatuses', response.data.results)
            commit('common/popLoading', 'fetchStatuses', { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', 'fetchStatuses', { root: true })
            reject(e)
          })
      })
    },
    fetchCurrentRegistry ({ commit, dispatch }, pk) {
      commit('common/clearError', null, { root: true })
      commit('common/pushLoading', 'fetchCurrentRegistry', { root: true })
      let _url = URL + 'school/api/list-food/' + pk + '/'

      session.get(_url)
        .then(data => {
          commit('setCurrentRegistry', data.data)
          commit('common/popLoading', 'fetchCurrentRegistry', { root: true })
        })
        .catch(e => {
          dispatch('common/setError', e, { root: true })
          commit('common/popLoading', 'fetchCurrentRegistry', { root: true })
        })
    },
    downloadRegistryFood ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadRegistryFood_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = URL + 'school/api/list-food-person/' + payload.id + '/get_file/'
        const download = require('js-file-download')
        session({ url: _url, method: 'GET', responseType: 'blob' })
          .then(response => {
            download(response.data,
              payload.filename,
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    downloadFoodReport ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadFoodReport_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = URL + 'school/api/list-food-person/' + payload.id + '/get_food_report/'
        const download = require('js-file-download')
        session({ url: _url, method: 'GET', responseType: 'blob' })
          .then(response => {
            download(response.data,
              payload.filename,
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    data (state) {
      return state.data
    },
    currentRegistry (state) {
      return state.currentRegistry
    },
    status: (state) => (statusId) => {
      let status = { 'name': '' }
      for (let i in state.statuses) {
        if (state.statuses[i]['id'] === statusId) {
          status = state.statuses[i]
          break
        }
      }
      return status
    }
  }
}
